// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/DotGothic16-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/PressStart2P-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/PixelifySans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/GohuFont14NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/BigBlueTerm437NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/HeavyDataNerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DotGothic16";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"); }

@font-face {
  font-family: "Press Start 2P";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@font-face {
  font-family: "Pixelify Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

@font-face {
  font-family: "Gohu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

@font-face {
  font-family: "Big Blue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

@font-face {
  font-family: "Heavy Data";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

:root {
  --main-font: "Pixelify Sans", sans-serif;
  --clock-font: "DotGothic16", sans-serif;
  --log-in-font: "Press Start 2P", sans-serif;
  --Gohu-test: "Gohu", sans-serif;
  --Big-Blue-test: "Big Blue", sans-serif;
  --Heavy-Data-test: "Heavy Data", sans-serif; }

.slider-box {
  width: 90px;
  height: 28px;
  background-color: #969696;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  border-top: 1px black solid;
  border-right: 1px white solid;
  border-bottom: 1px white solid;
  border-left: 1px black solid; }
  .slider-box *:hover {
    cursor: pointer; }

.toggle-name {
  width: 45px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--main-font);
  font-size: medium;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none; }

.slider-toggle {
  height: 24px;
  width: 43px;
  padding: 1px 0px;
  background-color: #CCCCCC;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-top: 1px white solid;
  border-right: 1px black solid;
  border-bottom: 1px black solid;
  border-left: 1px white solid;
  position: absolute; }

.burger-stack {
  width: 20px;
  height: 4px;
  background-color: #969696;
  border-top: 1px white solid;
  border-right: 1px black solid;
  border-bottom: 1px black solid;
  border-left: 1px white solid; }

/* PRO STYLING */
.slider-box-pro {
  width: 90px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  border-radius: 30px;
  border: 2px rgba(0, 0, 0, 0.2) solid;
  transition: background-color .1s;
  margin-right: 20px; }
  .slider-box-pro *:hover {
    cursor: pointer; }

.toggle-name-pro {
  width: 45px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: medium;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none; }

.slider-toggle-pro {
  position: absolute;
  background-color: #CCCCCC;
  box-shadow: 0 0 2px black;
  width: 40px;
  height: 32px;
  border-radius: 30px;
  transition: margin-left ease-in .1s;
  margin-top: 4px; }
`, "",{"version":3,"sources":["webpack://./src/components/style_imports/_fonts.scss","webpack://./src/components/Slider/Slider.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,+DAAkE,EAAA;;AAGtE;EACI,6BAA6B;EAC7B,4CAAgD,EAAA;;AAGpD;EACI,4BAA4B;EAC5B,4CAAgD,EAAA;;AAGpD;EACI,mBAAmB;EACnB,4CAAsD,EAAA;;AAG1D;EACI,uBAAuB;EACvB,4CAA0D,EAAA;;AAG9D;EACI,yBAAyB;EACzB,4CAAqD,EAAA;;AAGzD;EACI,wCAAY;EACZ,uCAAa;EACb,2CAAc;EACd,+BAAY;EACZ,uCAAgB;EAChB,2CAAkB,EAAA;;AClCtB;EACI,WAAW;EACX,YAAY;EACZ,yBAAoC;EACpC,kBAAkB;EAElB,aAAa;EACb,8BAA8B;EAE9B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B,EAAA;EAZhC;IAeQ,eAAe,EAAA;;AAIvB;EACI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAEnB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB,EAAA;;AAGzB;EACI,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EAEnB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAE5B,kBAAkB,EAAA;;AAGtB;EACI,WAAW;EACX,WAAW;EAEX,yBAAoC;EAEpC,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B,EAAA;;AAGhC,gBAAA;AAEA;EACI,WAAW;EACX,YAAY;EAEZ,aAAa;EACb,8BAA8B;EAE9B,mBAAmB;EACnB,oCAAmD;EAEnD,gCAAgC;EAChC,kBAAkB,EAAA;EAXtB;IAcQ,eAAe,EAAA;;AAIvB;EACI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAEnB,YAAY;EACZ,iBAAiB;EAEjB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB,EAAA;;AAGzB;EACI,kBAAkB;EAClB,yBAAyB;EAEzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,eAAe,EAAA","sourcesContent":["@font-face {\n    font-family: \"DotGothic16\";\n    src: url(\"../../fonts/DotGothic16-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"Press Start 2P\";\n    src: url(\"../../fonts/PressStart2P-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Pixelify Sans\";\n    src: url(\"../../fonts/PixelifySans-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Gohu\";\n    src: url(\"../../fonts/GohuFont14NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Big Blue\";\n    src: url(\"../../fonts/BigBlueTerm437NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Heavy Data\";\n    src: url(\"../../fonts/HeavyDataNerdFont-Regular.ttf\");\n}\n\n:root {\n    --main-font: \"Pixelify Sans\", sans-serif;\n    --clock-font: \"DotGothic16\", sans-serif;\n    --log-in-font: \"Press Start 2P\", sans-serif;\n    --Gohu-test: \"Gohu\", sans-serif;\n    --Big-Blue-test: \"Big Blue\", sans-serif;\n    --Heavy-Data-test: \"Heavy Data\", sans-serif;\n}","@import '../style_imports/fonts';\n\n.slider-box {\n    width: 90px;\n    height: 28px;\n    background-color: rgb(150, 150, 150);\n    margin-right: 10px;\n\n    display: flex;\n    justify-content: space-between;\n\n    border-top: 1px black solid;\n    border-right: 1px white solid;\n    border-bottom: 1px white solid;\n    border-left: 1px black solid;\n\n    & *:hover {\n        cursor: pointer;\n    }\n}\n\n.toggle-name {\n    width: 45px;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-family: var(--main-font);\n    font-size: medium;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.slider-toggle {\n    height: 24px;\n    width: 43px;\n    padding: 1px 0px;\n    background-color: #CCCCCC;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n\n    border-top: 1px white solid;\n    border-right: 1px black solid;\n    border-bottom: 1px black solid;\n    border-left: 1px white solid;\n\n    position: absolute;\n}\n\n.burger-stack {\n    width: 20px;\n    height: 4px;\n\n    background-color: rgb(150, 150, 150);\n\n    border-top: 1px white solid;\n    border-right: 1px black solid;\n    border-bottom: 1px black solid;\n    border-left: 1px white solid;\n}\n\n/* PRO STYLING */\n\n.slider-box-pro {\n    width: 90px;\n    height: 40px;\n\n    display: flex;\n    justify-content: space-between;\n\n    border-radius: 30px;\n    border: 2px rgba($color: #000000, $alpha: .2) solid;\n    // box-shadow: 0 0 1px black;\n    transition: background-color .1s;\n    margin-right: 20px;\n\n    & *:hover {\n        cursor: pointer;\n    }\n}\n\n.toggle-name-pro {\n    width: 45px;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    color: white;\n    font-size: medium;\n\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n}\n\n.slider-toggle-pro {\n    position: absolute;\n    background-color: #CCCCCC;\n    // border: 1px rgba($color: #000000, $alpha: .4) solid;\n    box-shadow: 0 0 2px black;\n    width: 40px;\n    height: 32px;\n    border-radius: 30px;\n    transition: margin-left ease-in .1s;\n    margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
